import { render } from "./ResetPasswordConfirmation.vue?vue&type=template&id=43889e85&scoped=true"
import script from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js"

import "./ResetPasswordConfirmation.vue?vue&type=style&index=0&id=43889e85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43889e85"]])

export default __exports__